import * as React from 'react'

export const LockIconLight = () => (
  <svg
    width='14'
    height='18'
    viewBox='0 0 14 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.1426 6H11.2854V4.28571C11.2854 1.92 9.36544 0 6.99972 0C4.63401 0 2.71401 1.92 2.71401 4.28571V6H1.85686C0.914007 6 0.142578 6.77143 0.142578 7.71429V16.2857C0.142578 17.2286 0.914007 18 1.85686 18H12.1426C13.0854 18 13.8569 17.2286 13.8569 16.2857V7.71429C13.8569 6.77143 13.0854 6 12.1426 6ZM6.99972 13.7143C6.05686 13.7143 5.28544 12.9429 5.28544 12C5.28544 11.0571 6.05686 10.2857 6.99972 10.2857C7.94258 10.2857 8.71401 11.0571 8.71401 12C8.71401 12.9429 7.94258 13.7143 6.99972 13.7143ZM9.65686 6H4.34258V4.28571C4.34258 2.82 5.53401 1.62857 6.99972 1.62857C8.46544 1.62857 9.65686 2.82 9.65686 4.28571V6Z'
      fill='white'
      fillOpacity='0.9'
    />
  </svg>
)
